import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Search } from 'lucide-react';
import { telecharger } from './constantes';

export const nomComplet = (s) => `${s.prenom} ${s.nom}`.trim() || 'Stagiaire';
export const wordStagiaire = (s, bloc) => telecharger(`/guide-bpjeps/suivi/${s.user_id}/word?bloc=${bloc}`, `Brouillon_${bloc}_${s.nom}_${s.prenom}.docx`);

export const useSuivi = () => {
  const [data, setData] = useState(null);
  const recharger = useCallback(() => {
    axios.get('/guide-bpjeps/suivi').then(({ data: d }) => setData(d)).catch(() => toast.error('Impossible de charger la liste des stagiaires'));
  }, []);
  useEffect(() => { recharger(); }, [recharger]);
  return { data, recharger };
};

export const useFiltres = (stagiaires) => {
  const [q, setQ] = useState('');
  const [session, setSession] = useState('');
  const liste = (stagiaires || []).filter((s) => (!session || s.session === session) && nomComplet(s).toLowerCase().includes(q.trim().toLowerCase()));
  return { q, setQ, session, setSession, liste };
};

export const Filtres = ({ f, sessions, prefixe }) => (
  <div className="flex flex-wrap gap-2">
    <label className="flex min-w-[220px] flex-1 items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm">
      <Search className="h-4 w-4 text-slate-400" />
      <input value={f.q} onChange={(e) => f.setQ(e.target.value)} placeholder="Rechercher un stagiaire" className="w-full outline-none" data-testid={`${prefixe}-recherche`} />
    </label>
    <select value={f.session} onChange={(e) => f.setSession(e.target.value)} className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm" data-testid={`${prefixe}-session`}>
      <option value="">Toutes les sessions</option>
      {sessions.map((s) => <option key={s} value={s}>Session {s}</option>)}
    </select>
  </div>
);

export const BadgeAcces = ({ ok, testId }) => (
  <span className={`whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${ok ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'}`} data-testid={testId}>
    {ok ? 'Ouvert' : 'Fermé'}
  </span>
);
